import React, { useState, useRef } from 'react';
import ReactDOM from 'react-dom';
import './DTViewer.css';

const dtData = {
  aduanaCodigo: '5001',
  aduanaNombre: 'PRINCIPAL LA GUAIRA',
  numeroViaje: '6075',
  fechaSalida: '14/02/2026',
  fechaLlegada: '18/02/2026',
  horaLlegada: '',
  numeroRegistro: '2026',
  numeroRegistro2: '74',
  numeroReferenciaDT: '262373793',
  tipoDT: 'MBL',
  tipoDTDesc: 'CONOCIMIENTO DE EMBARQUE',
  uso: '23',
  ultimaDescarga: '',
  dtLinea: '19',
  documentoPrevio: '',
  ucr: '',
  lugarEmbarqueCod: 'AEJEA',
  lugarEmbarqueNombre: 'JEBEL ALI',
  lugarDesembarqueCod: 'VELAG',
  lugarDesembarqueNombre: 'LA GUAIRA',
  transportistaCod: 'ATI516',
  transportistaNombre: 'SETA NAVIERA, C.A.',
  transportistaDireccion1: 'CALLE COMERCIO Nº 44 NORTE',
  transportistaDireccion2: 'PUERTO CABELLO EDO CARABOBO',
  transportistaZonaPostal: 'ZONA POSTAL 2005',
  transportistaExtra: 'null',
  transportistaRef: '',
  exportadorNombre: 'GT CARS HOLDING',
  exportadorDireccion1: 'PO BOX: 89006 DFC, DUBAIJAE EMAIL',
  exportadorDireccion2: 'GTCARS.DXB@GMAIL.COM PHONE: +971',
  transporteModo: '1',
  transporteModoDesc: 'TRANSPORTE MARITIMO',
  transporteNombre: 'X-PRESS NETRAVATI',
  transporteNacionalidad: 'SG',
  transporteNacionalidadDesc: 'SINGAPUR',
  // Consignatario
  consignatarioNombre: 'CARGA EXPRESS UNICOR C.A',
  consignatarioRIF: 'RIF J-30868959-9 ADDRESS: CALLE PRI',
  consignatarioDireccion1: 'MERA DE SECRESTAA, CRUCE CON CALLE',
  // Notificar
  notificarNombre: 'CARGA EXPRESS UNICOR C.A',
  notificarRIF: 'RIF J-30868959-9 ADDRESS: CALLE PRI',
  notificarDireccion1: 'MERA DE SECRESTAA, CRUCE CON CALLE',
  // Detalles mercancías
  contenedores: '1',
  codigoEmbalaje: 'PT',
  codigoEmbalajeDesc: 'PAQUETE',
  estado: 'MST DEG',
  numDocDesconsolida: '1',
  marcasNum: '',
  paquetesManifestados: '3.00',
  paquetesRestantes: '3.00',
  pesoBrutoManifestado: '3,851.00',
  pesoBrutoRestante: '3,851.00',
  volumenMC: '0.00',
  descripcionMercancias: 'NISSAN X-TRAIL MODEL 2025 CHASSIS NO: JN8AT3MM3SW029044  ENGINE NO: P R25582595F  COLOR: WHITE  SUZUKI DZ RE MODEL 2026 CHASSIS NO:',
  // Localizar
  localizarCod: '5001024DT',
  localizarNombre: 'BOLIVARIANA DE PUERTOS, S.A.',
  // Valor Declarado
  indPC: '',
  montoMonedaFlete: '',
  valorAduanas: '',
  valorTransporte: '',
  valorSeguro: '',
  numeroPrecintos: '',
  marcasPrecintos: '',
  emisor: '',
  informacion: '',
  // Transporte adicional
  transito: '',
  referenciaDocTransito: '',
  transbordo: '',
  referenciaDocTransbordo: '',
  transportistaBottom: '',
};

function DTViewer({ onClose }) {
  const [isDragging, setIsDragging] = useState(false);
  const [position, setPosition] = useState({ x: null, y: null });
  const [openMenu, setOpenMenu] = useState(null);
  const [activeTab, setActiveTab] = useState('DT');
  const dragOffset = useRef({ x: 0, y: 0 });
  const dialogRef = useRef(null);
  const menuRef = useRef(null);

  const handleMouseDown = (e) => {
    if (dialogRef.current) {
      const rect = dialogRef.current.getBoundingClientRect();
      dragOffset.current = { x: e.clientX - rect.left, y: e.clientY - rect.top };
      setIsDragging(true);
    }
  };

  const handleMouseMove = (e) => {
    if (isDragging) {
      setPosition({
        x: e.clientX - dragOffset.current.x,
        y: e.clientY - dragOffset.current.y,
      });
    }
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  const style = position.x !== null
    ? { left: position.x, top: position.y, transform: 'none' }
    : {};

  const menus = [
    { label: 'Archivo', items: ['Guardar', 'Cerrar'] },
    { label: 'Editar', items: ['Copiar', 'Pegar'] },
    { label: 'Ver', items: ['Actualizar'] },
    { label: 'Ayuda', items: ['Acerca de'] },
  ];

  return ReactDOM.createPortal(
    <div
      className="dt-viewer-overlay"
      onMouseMove={handleMouseMove}
      onMouseUp={handleMouseUp}
    >
      <div className="dt-viewer-window" ref={dialogRef} style={style}>
        {/* Barra de título */}
        <div className="dt-viewer-titlebar" onMouseDown={handleMouseDown}>
          <span className="dt-viewer-title">D/T - Ver [{dtData.aduanaCodigo}]</span>
          <button className="dt-viewer-close" onClick={onClose}>×</button>
        </div>

        {/* Menú */}
        <div className="dt-viewer-menubar" ref={menuRef}>
          {menus.map((menu, idx) => (
            <div className="dt-viewer-menu-item" key={menu.label}>
              <button
                className={`dt-viewer-menu-btn ${openMenu === idx ? 'active' : ''}`}
                onClick={() => setOpenMenu(openMenu === idx ? null : idx)}
                onMouseEnter={() => openMenu !== null && setOpenMenu(idx)}
              >
                {menu.label}
              </button>
              {openMenu === idx && (
                <div className="dt-viewer-dropdown">
                  {menu.items.map((item) => (
                    <button
                      className="dt-viewer-dropdown-item"
                      key={item}
                      onClick={() => {
                        if (item === 'Cerrar') onClose();
                        setOpenMenu(null);
                      }}
                    >
                      {item}
                    </button>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Contenido scrollable */}
        <div className="dt-viewer-content">
          {/* Banner */}
          <div className="dt-viewer-banner">
            <span>Manifiesto - Documento de transporte</span>
          </div>

          {/* Aduana */}
          <fieldset className="dt-viewer-fieldset">
            <legend>Aduana de salida / llegada</legend>
            <div className="dt-viewer-row">
              <div className="dt-viewer-field" style={{ width: '80px' }}>
                <input className="dt-viewer-input" value={dtData.aduanaCodigo} readOnly />
              </div>
              <div className="dt-viewer-field" style={{ flex: 1 }}>
                <input className="dt-viewer-input" value={dtData.aduanaNombre} readOnly />
              </div>
            </div>
          </fieldset>

          {/* Información General */}
          <fieldset className="dt-viewer-fieldset">
            <legend>Información General</legend>

            {/* Fila 1 */}
            <div className="dt-viewer-row">
              <div className="dt-viewer-field">
                <label>Número de viaje</label>
                <input className="dt-viewer-input" value={dtData.numeroViaje} readOnly />
              </div>
              <div className="dt-viewer-field">
                <label>Fecha de salida</label>
                <input className="dt-viewer-input" value={dtData.fechaSalida} readOnly />
              </div>
              <div className="dt-viewer-field">
                <label>Fecha de llegada</label>
                <input className="dt-viewer-input" value={dtData.fechaLlegada} readOnly />
              </div>
              <div className="dt-viewer-field" style={{ width: '90px' }}>
                <label>Hora de llegada</label>
                <input className="dt-viewer-input" value={dtData.horaLlegada} readOnly />
              </div>
              <div className="dt-viewer-field">
                <label>Número de registro</label>
                <div className="dt-viewer-row-inline">
                  <input className="dt-viewer-input" value={dtData.numeroRegistro} readOnly />
                  <input className="dt-viewer-input" style={{ width: '50px' }} value={dtData.numeroRegistro2} readOnly />
                </div>
              </div>
            </div>

            {/* Fila 2 */}
            <div className="dt-viewer-row">
              <div className="dt-viewer-field">
                <label>Número referencia DT</label>
                <input className="dt-viewer-input" value={dtData.numeroReferenciaDT} readOnly />
              </div>
              <div className="dt-viewer-field">
                <label>Tipo DT</label>
                <div className="dt-viewer-row-inline">
                  <input className="dt-viewer-input" style={{ width: '50px' }} value={dtData.tipoDT} readOnly />
                  <input className="dt-viewer-input" style={{ flex: 1 }} value={dtData.tipoDTDesc} readOnly />
                </div>
              </div>
              <div className="dt-viewer-field" style={{ width: '50px' }}>
                <label>Uso</label>
                <input className="dt-viewer-input" value={dtData.uso} readOnly />
              </div>
              <div className="dt-viewer-field" style={{ width: '100px' }}>
                <label>Última descarga</label>
                <input className="dt-viewer-input" value={dtData.ultimaDescarga} readOnly />
              </div>
              <div className="dt-viewer-field" style={{ width: '60px' }}>
                <label>DT línea</label>
                <input className="dt-viewer-input" value={dtData.dtLinea} readOnly />
              </div>
            </div>

            {/* Fila 3 */}
            <div className="dt-viewer-row">
              <div className="dt-viewer-field" style={{ flex: 1 }}>
                <label>Documento previo</label>
                <input className="dt-viewer-input" value={dtData.documentoPrevio} readOnly />
              </div>
              <div className="dt-viewer-field" style={{ flex: 1 }}>
                <label>UCR</label>
                <input className="dt-viewer-input" value={dtData.ucr} readOnly />
              </div>
            </div>

            {/* Fila 4 - Lugares */}
            <div className="dt-viewer-row">
              <div className="dt-viewer-field" style={{ flex: 1 }}>
                <label>Lugar de embarque</label>
                <div className="dt-viewer-row-inline">
                  <input className="dt-viewer-input" style={{ width: '60px' }} value={dtData.lugarEmbarqueCod} readOnly />
                  <input className="dt-viewer-input" style={{ flex: 1 }} value={dtData.lugarEmbarqueNombre} readOnly />
                </div>
              </div>
              <div className="dt-viewer-field" style={{ flex: 1 }}>
                <label>Lugar de desembarque</label>
                <div className="dt-viewer-row-inline">
                  <input className="dt-viewer-input" style={{ width: '60px' }} value={dtData.lugarDesembarqueCod} readOnly />
                  <input className="dt-viewer-input" style={{ flex: 1 }} value={dtData.lugarDesembarqueNombre} readOnly />
                </div>
              </div>
            </div>
          </fieldset>

          {/* Transportista y Exportador */}
          <div className="dt-viewer-row-sections">
            <fieldset className="dt-viewer-fieldset" style={{ flex: 1 }}>
              <legend>Transportista</legend>
              <div className="dt-viewer-text-block">
                <input className="dt-viewer-input" value={dtData.transportistaCod} readOnly />
                <div className="dt-viewer-text-lines">
                  <span>{dtData.transportistaNombre}</span>
                  <span>{dtData.transportistaDireccion1}</span>
                  <span>{dtData.transportistaDireccion2}</span>
                  <span>{dtData.transportistaZonaPostal}</span>
                  <span>{dtData.transportistaExtra}</span>
                </div>
                <div className="dt-viewer-row" style={{ marginTop: '4px' }}>
                  <div className="dt-viewer-field" style={{ flex: 1 }}>
                    <label>Transportista</label>
                    <input className="dt-viewer-input" value={dtData.transportistaRef} readOnly />
                  </div>
                </div>
              </div>
            </fieldset>

            <fieldset className="dt-viewer-fieldset" style={{ flex: 1 }}>
              <legend>Exportador/Embarcador</legend>
              <div className="dt-viewer-text-block">
                <div className="dt-viewer-text-lines">
                  <span>{dtData.exportadorNombre}</span>
                  <span>{dtData.exportadorDireccion1}</span>
                  <span>{dtData.exportadorDireccion2}</span>
                </div>
              </div>
            </fieldset>
          </div>

          {/* Transporte */}
          <fieldset className="dt-viewer-fieldset">
            <legend>Transporte</legend>
            <div className="dt-viewer-row">
              <div className="dt-viewer-field" style={{ width: '50px' }}>
                <label>Modo</label>
                <input className="dt-viewer-input" value={dtData.transporteModo} readOnly />
              </div>
              <div className="dt-viewer-field" style={{ flex: 1 }}>
                <label>&nbsp;</label>
                <input className="dt-viewer-input" value={dtData.transporteModoDesc} readOnly />
              </div>
              <div className="dt-viewer-field" style={{ flex: 1 }}>
                <label>Nombre</label>
                <input className="dt-viewer-input" value={dtData.transporteNombre} readOnly />
              </div>
            </div>
            <div className="dt-viewer-row">
              <div className="dt-viewer-field" style={{ width: '50px' }}>
                <label>Nacionalidad</label>
                <input className="dt-viewer-input" value={dtData.transporteNacionalidad} readOnly />
              </div>
              <div className="dt-viewer-field" style={{ flex: 1 }}>
                <label>&nbsp;</label>
                <input className="dt-viewer-input" value={dtData.transporteNacionalidadDesc} readOnly />
              </div>
            </div>
          </fieldset>

          {/* Consignatario y Notificar */}
          <div className="dt-viewer-row-sections">
            <fieldset className="dt-viewer-fieldset" style={{ flex: 1 }}>
              <legend>Consignatario</legend>
              <div className="dt-viewer-text-lines">
                <span>{dtData.consignatarioNombre}</span>
                <span>{dtData.consignatarioRIF}</span>
                <span>{dtData.consignatarioDireccion1}</span>
              </div>
            </fieldset>
            <fieldset className="dt-viewer-fieldset" style={{ flex: 1 }}>
              <legend>Notificar</legend>
              <div className="dt-viewer-text-lines">
                <span>{dtData.notificarNombre}</span>
                <span>{dtData.notificarRIF}</span>
                <span>{dtData.notificarDireccion1}</span>
              </div>
            </fieldset>
          </div>

          {/* Detalles mercancías */}
          <fieldset className="dt-viewer-fieldset">
            <legend>Detalles mercancías</legend>
            <div className="dt-viewer-row">
              <div className="dt-viewer-field" style={{ width: '80px' }}>
                <label>Contenedores</label>
                <input className="dt-viewer-input" value={dtData.contenedores} readOnly />
              </div>
              <div className="dt-viewer-field">
                <label>Código de Embalaje</label>
                <div className="dt-viewer-row-inline">
                  <input className="dt-viewer-input" style={{ width: '40px' }} value={dtData.codigoEmbalaje} readOnly />
                  <input className="dt-viewer-input" style={{ flex: 1 }} value={dtData.codigoEmbalajeDesc} readOnly />
                </div>
              </div>
              <div className="dt-viewer-field">
                <label>Estado</label>
                <input className="dt-viewer-input" value={dtData.estado} readOnly />
              </div>
              <div className="dt-viewer-field">
                <label>Número de documentos desconsolida.</label>
                <input className="dt-viewer-input" value={dtData.numDocDesconsolida} readOnly />
              </div>
            </div>
            <div className="dt-viewer-row">
              <div className="dt-viewer-field" style={{ flex: 1 }}>
                <label>Marcas y Núm.</label>
                <input className="dt-viewer-input" value={dtData.marcasNum} readOnly />
              </div>
            </div>
            <div className="dt-viewer-row">
              <div className="dt-viewer-field">
                <label>Paquetes manifestados</label>
                <input className="dt-viewer-input" value={dtData.paquetesManifestados} readOnly />
              </div>
              <div className="dt-viewer-field">
                <label>Paquetes restantes</label>
                <input className="dt-viewer-input" value={dtData.paquetesRestantes} readOnly />
              </div>
              <div className="dt-viewer-field">
                <label>Peso bruto manifestado</label>
                <input className="dt-viewer-input" value={dtData.pesoBrutoManifestado} readOnly />
              </div>
              <div className="dt-viewer-field">
                <label>Peso bruto restante</label>
                <input className="dt-viewer-input" value={dtData.pesoBrutoRestante} readOnly />
              </div>
              <div className="dt-viewer-field">
                <label>Volúmen (MC)</label>
                <input className="dt-viewer-input" value={dtData.volumenMC} readOnly />
              </div>
            </div>
            <div className="dt-viewer-row">
              <div className="dt-viewer-field" style={{ flex: 1 }}>
                <label>Descripción de las mercancías</label>
                <textarea className="dt-viewer-textarea" value={dtData.descripcionMercancias} readOnly rows={3} />
              </div>
            </div>
          </fieldset>

          {/* Localizar */}
          <fieldset className="dt-viewer-fieldset">
            <legend>Localizar</legend>
            <div className="dt-viewer-row">
              <div className="dt-viewer-field" style={{ width: '100px' }}>
                <input className="dt-viewer-input" value={dtData.localizarCod} readOnly />
              </div>
              <div className="dt-viewer-field" style={{ flex: 1 }}>
                <input className="dt-viewer-input" value={dtData.localizarNombre} readOnly />
              </div>
            </div>
          </fieldset>

          {/* Valor Declarado y Detalle Precintos */}
          <div className="dt-viewer-banner">
            <span>Valor Declarado y Detalle Precintos</span>
          </div>
          <fieldset className="dt-viewer-fieldset">
            <div className="dt-viewer-row">
              <div className="dt-viewer-field">
                <label>Ind. P/C</label>
                <input className="dt-viewer-input" value={dtData.indPC} readOnly />
              </div>
              <div className="dt-viewer-field" style={{ flex: 1 }}>
                <label>Monto y moneda flete</label>
                <input className="dt-viewer-input" value={dtData.montoMonedaFlete} readOnly />
              </div>
            </div>
            <div className="dt-viewer-row">
              <div className="dt-viewer-field" style={{ flex: 1 }}>
                <label>Valor en aduanas</label>
                <input className="dt-viewer-input" value={dtData.valorAduanas} readOnly />
              </div>
              <div className="dt-viewer-field" style={{ flex: 1 }}>
                <label>Valor transporte</label>
                <input className="dt-viewer-input" value={dtData.valorTransporte} readOnly />
              </div>
              <div className="dt-viewer-field" style={{ flex: 1 }}>
                <label>Valor seguro</label>
                <input className="dt-viewer-input" value={dtData.valorSeguro} readOnly />
              </div>
            </div>
            <div className="dt-viewer-row">
              <div className="dt-viewer-field" style={{ flex: 1 }}>
                <label>Número precintos</label>
                <input className="dt-viewer-input" value={dtData.numeroPrecintos} readOnly />
              </div>
              <div className="dt-viewer-field" style={{ flex: 1 }}>
                <label>Marcas</label>
                <input className="dt-viewer-input" value={dtData.marcasPrecintos} readOnly />
              </div>
              <div className="dt-viewer-field" style={{ flex: 1 }}>
                <label>Emisor</label>
                <input className="dt-viewer-input" value={dtData.emisor} readOnly />
              </div>
            </div>
            <div className="dt-viewer-row">
              <div className="dt-viewer-field" style={{ flex: 1 }}>
                <label>Información</label>
                <input className="dt-viewer-input" value={dtData.informacion} readOnly />
              </div>
            </div>
          </fieldset>

          {/* Transporte (sección inferior) */}
          <div className="dt-viewer-banner">
            <span>Transporte</span>
          </div>
          <fieldset className="dt-viewer-fieldset">
            <div className="dt-viewer-row">
              <div className="dt-viewer-field" style={{ flex: 1 }}>
                <label>Tránsito</label>
                <input className="dt-viewer-input" value={dtData.transito} readOnly />
              </div>
              <div className="dt-viewer-field" style={{ flex: 1 }}>
                <label>Referencia doc.</label>
                <input className="dt-viewer-input" value={dtData.referenciaDocTransito} readOnly />
              </div>
            </div>
            <div className="dt-viewer-row">
              <div className="dt-viewer-field" style={{ flex: 1 }}>
                <label>Transbordo</label>
                <input className="dt-viewer-input" value={dtData.transbordo} readOnly />
              </div>
              <div className="dt-viewer-field" style={{ flex: 1 }}>
                <label>Referencia doc.</label>
                <input className="dt-viewer-input" value={dtData.referenciaDocTransbordo} readOnly />
              </div>
            </div>
            <div className="dt-viewer-row">
              <div className="dt-viewer-field" style={{ flex: 1 }}>
                <label>Transportista</label>
                <input className="dt-viewer-input" value={dtData.transportistaBottom} readOnly />
              </div>
            </div>
          </fieldset>
        </div>

        {/* Tabs inferiores */}
        <div className="dt-viewer-tabs">
          {['DT', 'Contenedores', 'Dividir', 'Descargado'].map((tab) => (
            <button
              key={tab}
              className={`dt-viewer-tab ${activeTab === tab ? 'active' : ''}`}
              onClick={() => setActiveTab(tab)}
            >
              {tab}
            </button>
          ))}
        </div>
      </div>
    </div>,
    document.body
  );
}

export default DTViewer;
